<template>
  <div>
    <vue-good-table
      style="width: 100%;"
      :rows="getPartsRequirement"
      :columns="columns"
      :pagination-options="paginationOptions"
      :search-options="{
      enabled: true,
      trigger: 'enter',
      placeholder: 'Procurar',
    }"
      styleClass="vgt-table condensed">
      <div slot="emptystate" class="text-center">
        Nenhum resultado encontrado
      </div>
      <template slot="column-filter" slot-scope="{ column, updateFilters }">
        <v-select
          appendToBody
          v-if="column.filterOptions && column.filterOptions.enabled"
          :options="column.filterOptions.items"
          :placeholder="column.filterOptions.placeholder || 'Selecione'"
          @input="(valuesArray) => updateFilters(column, valuesArray)">
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              Nenhuma resultado encontrado para <em>{{ search }}</em>.
            </template>
            <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
          </template>
        </v-select>
      </template>

      <template slot="table-row" slot-scope="partsRequirement">
        <span class="font-medium" v-if="partsRequirement.column.field == 'empresa'">
          {{partsRequirement.row.fantasia || partsRequirement.row.empresa}}
        </span>
        <span class="font-medium" v-else-if="partsRequirement.column.field == 'peças'">
          <vs-dropdown class="cursor-pointer" vs-trigger-click>
            <a class="flex items-center" style="font-weight: 500; font-size: 1rem" href="#">
              {{ partsRequirement.row.jsonNecessidades.length }} itens
              <i class="material-icons"> expand_more </i>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item :divider="index != 0" v-for="(requirement, index) in partsRequirement.row.jsonNecessidades" v-bind:key="index">
                <b>{{requirement.marca}}</b>
                <br>
                <label class="truncate" v-for="(requirement, index) in requirement.necessidades" v-bind:key="index">
                  {{requirement.peca}} - {{requirement.modelo}}
                  <br>
                </label>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </span>
        <span class="font-medium" v-else-if="partsRequirement.column.field == 'ações'">
          <div>
            <feather-icon
              icon="EyeIcon"
              svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
              @click="viewPartsRequirement(partsRequirement.row.idNecessidadeDePeca)" />
            <feather-icon
              icon="Trash2Icon"
              svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
              @click="deletePartsRequirementDialog(partsRequirement.row)" />
          </div>
        </span>
        <span class="font-medium" v-else>
          {{partsRequirement.formattedRow[partsRequirement.column.field]}}
        </span>
      </template>

    </vue-good-table>
  </div>
</template>
<script>
import helpers from "@/helpers";
import { baseApiUrl } from "@/global";
import axios from "axios";

export default {
  data() {
    return {
      partsRequirement: [],
      helpers: null,
      columns: [],
      paginationOptions: {
        enabled: true,
        nextLabel: 'Próxima',
        prevLabel: 'Anterior',
        rowsPerPageLabel: 'Resultados por página',
        ofLabel: 'de',
        pageLabel: 'Página',
        allLabel: 'Todos',
        mode: 'pages',
        perPage: 15
      }
    }
  },
  computed: {
    getPartsRequirement() {
      return this.partsRequirement
    },
  },
  methods: {
    viewPartsRequirement(id) {
      this.$router.push(`/necessidadeDePecas/visualizar/${id}`)
    },
    deletePartsRequirementDialog(necessidadeDePeca) {
      this.idNecessidadeDePeca = necessidadeDePeca.idNecessidadeDePeca
      const index = necessidadeDePeca.index

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Excluir`,
        text: `Você tem certeza que excluir o N° "${index}"?`,
        accept: this.deletePartsRequirement,
        acceptText: "Excluir",
        cancelText: "Cancelar"
      })
    },
    async deletePartsRequirement() {
      try {
        this.$vs.loading();
        const idNecessidadeDePeca = this.idNecessidadeDePeca
        const response = await axios.delete(`${baseApiUrl}/partsRequirement/${idNecessidadeDePeca}`);
        this.$vs.notify({
          color: 'success',
          title: 'Excluido',
          text: `A necessidade de peça foi excluida com sucesso!`
        })
        this.partsRequirement = this.partsRequirement.filter(el => el.idNecessidadeDePeca != idNecessidadeDePeca)
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel excluir" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async loadPartsRequirement() {
      try {
        this.$vs.loading();
        const response = await axios.get(`${baseApiUrl}/partsRequirement`);
        this.partsRequirement = response.data
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel carregar" + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    mountTable() {
      this.columns = [{
          label: 'N°',
          field: 'index'
        },
        {
          label: 'Empresa',
          field: 'empresa',
        },
        {
          label: 'CPF/CNPJ',
          field: 'cpfCnpj',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'Peças',
          field: 'peças',
        },
        {
          label: 'Ações',
          field: 'ações',
          sortable: false
        }
      ]
    }
  },
  async created() {
    this.helpers = helpers
    let payload = {
      loading: this.$vs.loading
    }
    await this.loadPartsRequirement()
    this.mountTable()
    // this.getAllLabelFilters()
  },
}

</script>
<style lang="scss">
table.vgt-table {
  font-size: 1rem;
}

</style>
